var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1418 0L7.5 6.19121L1.85824 0L0 2.03922L7.5 10.2697L15 2.03922L13.1418 0Z",
    fill: "#007C7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownGreenIcon);
export default __webpack_public_path__ + "static/media/dropdown_green_icon.a16772f9c5ca088cefad86b5d11e85ce.svg";
export { ForwardRef as ReactComponent };